import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface SubCardTitleProps {
  title: string;
}
export const SubCardTitle = memo(function SubCardTitle({ title }: SubCardTitleProps) {
  return (
    <h2
      className={cn(
        textVariants.footnote,
        "text-medium flex h-4 items-center font-bold text-black/60 uppercase",
      )}
    >
      {title}
    </h2>
  );
});
